import styled from 'styled-components'
import {
  PiHandshakeLight,
  PiHandshakeFill,
  PiMagnifyingGlass,
  PiMagnifyingGlassFill,
  PiIdentificationCard,
  PiIdentificationCardFill,
  PiHouse,
  PiHouseFill,
  PiPlusCircle,
  PiPlusCircleFill,
} from 'react-icons/pi'
import { Link, useLocation } from 'react-router-dom'
import { MobileNavItem } from '../Navbar/MobileSlideOutMenu'
import { useIsActive } from 'hooks/useIsActive'

import * as S from './Footer.styles'
import footerLogo from 'assets/Name - White Transparent.svg'
import { Z_INDEX } from 'styles/z-index'
import { useState } from 'react'
import MobileDrawer from 'components/MobileDrawer'

const LogoIcon = styled.img`
  width: 100px;
`

type Props = {
  items: { label: string; to: string; onClick?: () => void }[]
}

const NavWrapper = styled.div`
  min-height: 64px;
  height: 64px;
`

const NavigationMenu = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  z-index: ${Z_INDEX.NAV};
  margin-right: auto;
  padding-left: 12px;
  gap: 24px;
  background: #fafafa;
`

const NavigationMenuItem = styled(Link)<{
  $isActive?: boolean
  $activeColor?: string
}>`
  font-weight: ${({ $isActive }) => ($isActive ? '500' : '300')};
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.05s ease-in-out;

  &:hover {
    background: rgb(44, 107, 78);
    text-decoration: none;
    color: #f2f4f7;
  }
`

function FooterNavMenu({ items }: Props) {
  const getIsActive = useIsActive()
  return (
    <NavigationMenu>
      {' '}
      {items.map(({ label, to, onClick }, i) => {
        return (
          <NavigationMenuItem
            $isActive={getIsActive(to)}
            $activeColor="#148552"
            to={to}
            replace={false}
            onClick={onClick || (() => {})}
            key={i}
          >
            {label}
          </NavigationMenuItem>
        )
      })}
    </NavigationMenu>
  )
}

export function MobileUnauthenticatedFooter() {
  const supportEmail = 'support@firstbite.io'
  const handleEmailClick = () => {
    window.open(`mailto:${supportEmail}`)
  }

  return (
    <NavWrapper className="bg-fb-dark-green">
      <div>
        <div className="flex justify-between">
          <FooterNavMenu
            items={[
              {
                label: 'Help',
                to: 'https://help.firstbite.io/',
              },
              {
                label: 'Privacy',
                to: '/privacy-policy',
              },
              {
                label: 'Terms',
                to: '/terms-of-use',
              },
              {
                label: 'Contact',
                to: '#',
                onClick: handleEmailClick,
              },
            ]}
          />
          <LogoIcon
            src={footerLogo}
            alt="logo"
            style={{
              marginRight: '10px',
            }}
          />
        </div>
      </div>
    </NavWrapper>
  )
}

const MobileFooterItem = styled(Link)<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  font-weight: 300;
  position: relative;
  color: ${({ $isActive }) => ($isActive ? '#191D23' : '#6E6E6E')};
  text-decoration: none;
  transition: color 0.2s ease;
`

const SearchIconWrapper = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $isActive }) => ($isActive ? '#191D23' : '#6E6E6E')};
`

const Span = styled.span`
  font-size: 12px;
`

const menuItems = [
  { icon: PiHouse, activeIcon: PiHouseFill, label: 'Home', to: '/' },
  {
    icon: PiHandshakeLight,
    activeIcon: PiHandshakeFill,
    label: 'Deals',
    to: '/deals',
  },
  {
    icon: PiIdentificationCard,
    activeIcon: PiIdentificationCardFill,
    label: 'Contacts',
    to: '/contacts',
  },
]

export function MobileFooter() {
  const getIsActive = useIsActive()
  const location = useLocation()
  const [isFooterOpen, setIsFooterOpen] = useState(false)

  // Check if on search page
  const isSearchActive = location.pathname === '/search'
  const isCreateActive = location.pathname.includes('create')

  return (
    <S.MobileWrapper>
      <S.MobileContent>
        {/* nav items  */}
        {menuItems.map((item: MobileNavItem) => {
          // Don't show as active if search modal is open
          const isItemActive =
            !isSearchActive && !isCreateActive && getIsActive(item.to)
          return (
            <MobileFooterItem
              $isActive={isItemActive}
              to={item.to}
              key={item.label}
            >
              {isItemActive ? <item.activeIcon /> : <item.icon />}
              <Span>{item.label}</Span>
            </MobileFooterItem>
          )
        })}

        {/* popup actions  */}
        <MobileFooterItem to="/search" $isActive={isSearchActive}>
          <SearchIconWrapper $isActive={isSearchActive}>
            {isSearchActive ? <PiMagnifyingGlassFill /> : <PiMagnifyingGlass />}
          </SearchIconWrapper>
          <Span>Search</Span>
        </MobileFooterItem>
        <MobileFooterItem
          $isActive={isCreateActive}
          onClick={() => setIsFooterOpen(true)}
          to="#"
        >
          {isCreateActive ? <PiPlusCircleFill /> : <PiPlusCircle />}
          <Span>Create</Span>
        </MobileFooterItem>

        {isFooterOpen && (
          <MobileDrawer
            isOpen={isFooterOpen}
            onClose={() => setIsFooterOpen(false)}
          />
        )}
      </S.MobileContent>
    </S.MobileWrapper>
  )
}
